import { createIntl, createIntlCache } from 'react-intl';
import translations from '~/infra/i18n/locales';
import { getLocale } from '~/utils/getLocale';
import { CancelAppointment } from '~/domain/usecases/appointment/remote';
import { HttpClient, HttpStatusCode } from '~/data/protocols/http';
import { UnexpectedError, Forbidden, BadGateway } from '~/domain/errors';
import { AlertMessage } from '~/presentation/components/messages/AlertMessage';
import '~/infra/global/variables';

const cache = createIntlCache();

const intl = createIntl(
  {
    locale: String(getLocale()),
    messages: translations[getLocale()],
  },
  cache,
);

export class RemoteCancelAppointment implements CancelAppointment {
  private readonly url: string;

  private readonly httpClient: HttpClient<CancelAppointment.Model>;

  constructor(url: string, httClient: HttpClient<CancelAppointment.Model>) {
    this.url = url;
    this.httpClient = httClient;
  }

  cancel = async (
    params: CancelAppointment.Params,
  ): Promise<CancelAppointment.Model> => {
    const httpResponse = await this.httpClient.request({
      url: `${this.url}/${params.appointmentId}/cancel`,
      method: 'patch',
    });
    console.log('resposta do server: ', httpResponse);
    switch (httpResponse.statusCode) {
      case HttpStatusCode.noContent:
        return httpResponse.body;
      case HttpStatusCode.forbidden:
        throw new Forbidden();
      case HttpStatusCode.badGateway:
        throw new BadGateway();
      default:
        throw new UnexpectedError();
    }
  };
}
